'use es6';

import PortalIdParser from 'PortalIdParser';
export function getVideoDetailsUrl(crmObjectId, {
  source
} = {}) {
  const path = `/video-details/${PortalIdParser.get()}/crm-id/${crmObjectId}`;
  return source ? `${path}?source=${source}` : path;
}